var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status == 'loading')?_c('strong',{staticClass:"loading"},[_vm._v("Загрузка")]):_c('div',[(_vm.isActive)?_c('BoomerangActive'):_c('BoomerangNotActive')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }